module.exports = __webpack_public_path__ + "img/italy.14e96929.png";